type Error = string | {
    message?: string;
};

/**
 * Get a string for toast from an error
 * @param err - The error
 * @returns A string for toast
 */
export const getErrorMessage = (err: string | Error): string => {
    if (typeof err === "string") {
        return err;
    }
    if (typeof err === "object" && err !== null) {
        return err.message || "Oops... something went wrong";
    }
    return String(err);
};
